<template>
    <div class="creatives" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="page-header">
            <h1 class="page-title">{{ $t("messages.creatives") }} {{ adGroup.name }}</h1>
            <button class="create-button" @click="attachCreatives" :disabled="attachedCreativeIds.length === 0">
                {{ $t("messages.save") }}
            </button>
        </div>

        <div class="content">
            <table class="creatives-table table">
                <thead>
                    <tr>
                        <th class="actions"></th>
                        <th class="name">{{ $t('messages.creatives') }}</th>
                        <th class="status">{{ $t('messages.status') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in creatives" :key="row.id">
                        <td class="actions">
                            <input type="checkbox" :id="row.id" :value="row.id" v-model="attachedCreativeIds" />
                            <label class="checkbox-large" :for="row.id"></label>
                        </td>
                        <td class="creative-name name">
                            <div class="name-content">
                                <span @click="previewCreative(row)" class="title clickable">{{ row.creative }}</span>
                            </div>
                        </td>
                        <td class="status">
                            <span class="status-badge" :class="getStatusClass(row.status)">{{ getStatusText(row.status)
                                }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    name: "AdGroupCreatives",
    props: ["adGroup", "creatives", "attached_creative_ids", "user"],
    data() {
        return {
            attachedCreativeIds: [],
            fullscreenLoading: false,
        };
    },
    mounted() {
        this.attachedCreativeIds = [...(this.attached_creative_ids || [])];
    },
    methods: {
        attachCreatives() {
            if (this.attachedCreativeIds.length === 0) {
                this.$notify({ title: this.$t('messages.error_occurred'), message: this.$t('messages.select_at_least_one_creative'), type: 'error' });
                return;
            }
            this.fullscreenLoading = true;
            axios.post(`/ad-groups/${this.adGroup.id}/attach`, { creatives: [...this.attachedCreativeIds] })
                .then(() => {
                    this.fullscreenLoading = false;
                    this.$notify({ title: this.$t('messages.completed_successfully'), message: this.$t('messages.creatives_attached_successfully'), type: 'success' });
                }).catch((error) => {
                    this.fullscreenLoading = false;
                    this.$notify({ title: this.$t('messages.error_occurred'), message: error.response?.data?.message || this.$t('messages.failed_to_attach_creatives'), type: 'error' });
                });
        },
        previewCreative(row) {
            window.open(`/creatives/preview/${row.id}`, '_blank');
        },
        getStatusClass(status) {
            switch (status) {
                case 'active': return 'status-active';
                case 'pending': return 'status-pending';
                case 'completed': return 'status-completed';
                case 'paused': return 'status-paused';
                default: return 'status-default';
            }
        },
        getStatusText(status) {
            switch (status) {
                case 'active': return this.$t("messages.active_status");
                case 'paused': return this.$t("messages.paused_status");
                case 'pending': return this.$t("messages.pending_status");
                case 'completed': return this.$t("messages.completed_status");
                default: return status;
            }
        }
    }
};
</script>

<style scoped>
label.checkbox-large::before {
    content: url("/images/checkbox-large.svg");
    height: 20px;
    margin: 0;
}

label.checkbox-large:hover::before {
    content: url("/images/checkbox-large.svg");
    filter: invert(80%) sepia(58%) saturate(2515%) hue-rotate(204deg) brightness(85%) contrast(94%);
    height: 20px;
    margin: 0;
}

input[type="checkbox"]:checked+label.checkbox-large::before {
    content: url("/images/checkbox-checked-large.svg");
    filter: none;
    height: 20px;
    margin: 0;
}
</style>
